import React from "react";
import { useApp } from "../context/AppContext";
import ProductCard from "../components/ProductCard";
import SEO from "../components/SEO";

const ShopPage = ({ bestSellersOnly = false }) => {
  const { t, language, products } = useApp();
  const list = bestSellersOnly ? products.filter((p) => p.is_best_seller) : products;
  const title = bestSellersOnly ? t.sections.bestSellers : t.nav.shop;
  const isDE = language === "de";
  const path = bestSellersOnly ? "/best-sellers" : "/shop";

  return (
    <main className="pt-12 lg:pt-20 pb-24" data-testid="shop-page">
      <SEO
        title={bestSellersOnly
          ? (isDE ? "Bestseller — LUXERA KaLiMa" : "Best Sellers — LUXERA KaLiMa")
          : (isDE ? "Schmuck-Shop · Alle Stücke · Wasserfest 18K Gold" : "Shop All Jewelry · Waterproof 18K Gold Plated")}
        description={isDE
          ? `${list.length} Schmuckstücke — wasserfest, hypoallergen, 18K vergoldet. Armbänder, Ketten und mehr. Kostenloser Versand in Deutschland.`
          : `${list.length} luxury pieces — waterproof, hypoallergenic, 18K gold plated. Bracelets, necklaces & more. Free shipping in Germany.`}
        canonical={path}
        hreflangs={{ en: path, de: `${path}?lang=de` }}
        jsonLd={{
          "@context": "https://schema.org",
          "@type": "CollectionPage",
          "name": title,
          "hasPart": list.slice(0, 12).map((p) => ({
            "@type": "Product",
            "name": isDE ? p.name_de : p.name_en,
            "url": `/product/${p.slug}`,
            "image": p.images[0],
            "offers": { "@type": "Offer", "price": p.price.toFixed(2), "priceCurrency": "EUR" },
          })),
        }}
      />
      <div className="max-w-[1500px] mx-auto px-6 lg:px-10">
        <div className="text-center mb-14">
          <div className="text-[11px] tracking-[0.4em] uppercase text-[var(--gold-deep)] mb-4">— Collection</div>
          <h1 className="font-display text-5xl md:text-6xl lg:text-7xl">{title}</h1>
          <p className="text-sm text-[var(--grey)] mt-4">{list.length} {isDE ? "Stücke" : "pieces"}</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 lg:gap-12">
          {list.map((p, i) => <ProductCard key={p.id} product={p} index={i} />)}
        </div>
      </div>
    </main>
  );
};

export default ShopPage;
